// eslint-disable-next-line import/prefer-default-export
export class MoveMoney {
  constructor() {
    this.apiVersion = null;
    this.client = null;
    this.environment = null;
    this.robustPublicKey = null;
    this.microDeposits = null;
    this.isMicroDeposit = null;
    this.transferId = null;
    this.publicToken = null;
    this.verificationStatus = null;
    this.closeRequest = null;
    this.custodianImage = null;
    this.congratsImage = null;
    this.accounts = [];
    this.microDepositList = [];
    this.isMicroDepositListLoaded = false;
    this.directionId = null;
  }
}
